var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"srcset":`${_vm.path}/${_vm.src} ${_vm.scale? _vm.scale + 'x' : '2x'}`,"width":_vm.width ? _vm.width : ''},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }